import { WorkerAvailabilitySelectItem } from './WorkerAvailabilitySelectItem'
import { Stash } from '../../../../stash/Stash'
import { AssistantAssignmentList } from '../../../../../models/assistantAssignment'

export class AvailabilitySelectItemsStash extends Stash<WorkerAvailabilitySelectItem[]> {
  TAG = 'AvailabilitySelectItemsStash'

  constructor(initialValue?: WorkerAvailabilitySelectItem[]) {
    super(initialValue)
  }

  getCurrentIds(): number[] {
    return this.current.map((i) => i.availability.id)
  }

  protected isChangedImpl(): boolean {
    if (this.current.length !== this.previous.length) {
      console.log(`${this.TAG}#isChangedImpl: this.current.length !== this.previous.length`)
      return true
    }

    const checkedCurrentAvailabilityIds = new Set<number>()

    // For each availability in current, find corresponding in previous
    for (const i of this.current) {
      const previousI = this.previous.find((prev) => prev.availability.id === i.availability.id)
      if (!previousI) {
        console.log(`${this.TAG}#isChangedImpl: !previousI`)
        return true
      } // Something in current that was not in previous

      if (this.checkDifferences(previousI, i)) {
        console.log(`${this.TAG}#isChangedImpl: this.checkDifferences(previousI, i)`)
        return true
      }

      // Also compare

      checkedCurrentAvailabilityIds.add(i.availability.id)
    }

    for (const i of this.previous) {
      if (checkedCurrentAvailabilityIds.has(i.availability.id)) continue

      const currentI = this.current.find((curr) => curr.availability.id === i.availability.id)
      if (!currentI) {
        console.log(`${this.TAG}#isChangedImpl: !currentI`)
        return true
      } // Something was in previous that is not in current

      if (this.checkDifferences(currentI, i)) {
        console.log(`${this.TAG}#isChangedImpl: this.checkDifferences(currentI, i)`)
        return true
      }
    }

    return false
  }

  checkDifferences(item1: WorkerAvailabilitySelectItem, item2: WorkerAvailabilitySelectItem) {
    if (item1.status?.name !== item2.status?.name) return true
    // if (item1.assistanceAfterHHMM !== item2.assistanceAfterHHMM) return true
    // if (item1.assistanceBeforeHHMM !== item2.assistanceBeforeHHMM) return true

    if (item1.availability.dt_start?.getTime() !== item2.availability.dt_start?.getTime()) return true
    if (item1.availability.dt_end?.getTime() !== item2.availability.dt_end?.getTime()) return true

    if (
      AssistantAssignmentList.areAssignmentsDifferent(
        item1.availability.assistantAssignments,
        item2.availability.assistantAssignments,
      )
    )
      return true

    return false
  }
}
